import { render, staticRenderFns } from "./VProjectRatingList.vue?vue&type=template&id=39160198&"
import script from "./VProjectRatingList.vue?vue&type=script&lang=js&"
export * from "./VProjectRatingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports